import React, { Component } from 'react';
import { Button, FormGroup, FormControl, InputGroup, HelpBlock } from 'react-bootstrap';
import DeleteButton from '../../common/components/DeleteButton';
import { withTranslation } from 'react-i18next';

class PromoCodes extends Component {
	constructor(props) {
		super(props);
		this.handleNewPromoCodeChange = this.handleNewPromoCodeChange.bind(this);
		this.handleApplyClick = this.handleApplyClick.bind(this);
		this.state = {
			newPromoCode: '',
			applyWarning: ''
		};
	}

	handleNewPromoCodeChange(event) {
		const newPromoCode = event.target.value;
		this.setState({
			newPromoCode,
			applyWarning: newPromoCode ? this.props.t('FO_Booking_PromoCode_ApplyWarning') : ''
		});
	}

	handleApplyClick() {
		this.setState({
			applyWarning: ''
		}, () => this.props.onApply(this.state.newPromoCode));
	}

	render() {
		const { appliedPromoCodes, onRemove, errorMessage, t } = this.props;
		const { applyWarning, newPromoCode } = this.state;

		return <div>
			<h4>{t('FO_Booking_PromoCodes')}</h4>
			<FormGroup validationState={(applyWarning || errorMessage) ? 'error' : ''}>
				<InputGroup>
					<FormControl type='text' placeholder={t('FO_Booking_PromoCode_InputPlaceholder')} onChange={this.handleNewPromoCodeChange} />
					<InputGroup.Button>
						<Button disabled={!newPromoCode} onClick={this.handleApplyClick}>{t('FO_Booking_PromoCode_Apply')}</Button>
					</InputGroup.Button>
				</InputGroup>
				{(applyWarning || errorMessage) && <HelpBlock>{applyWarning || errorMessage}</HelpBlock>}
			</FormGroup>

			{appliedPromoCodes.map(promoCode => <div key={promoCode}>
				<span style={{ marginRight: '10px' }}>{promoCode}</span>
				<DeleteButton onDelete={() => onRemove(promoCode)}
					confirmationTitle={t('FO_Booking_PromoCode_ConfirmDeleteTitle')}
					confirmationMessage={t('FO_Booking_PromoCode_ConfirmDeleteMessage')} />
			</div>)}
		</div>;
	}
}

export default withTranslation()(PromoCodes);